export const ARTIFACT_ICONS: Record<string, string> = {
  html: 'assets/icons/html-svgrepo-com.svg',
  'text/html': 'assets/icons/html-svgrepo-com.svg',
  react: 'assets/icons/javascript-svgrepo-com.svg',
  javascript: 'assets/icons/javascript-svgrepo-com.svg',
  css: 'assets/icons/css-file-format-document-extension-file-format-svgrepo-com.svg',
  svg: 'assets/icons/file-svg-svgrepo-com.svg',
  markdown: 'assets/icons/markdown-svgrepo-com.svg',
  default: 'assets/icons/files-content.svg'
};

export const ARTIFACT_TYPE_COLORS: Record<string, string> = {
  html: '#e34c26',
  'text/html': '#e34c26',
  react: '#61dafb',
  javascript: '#f7df1e',
  css: '#1572b6',
  svg: '#ffb13b',
  markdown: '#083fa1',
  default: '#666'
};

export function getArtifactIcon(type: string): string {
  return ARTIFACT_ICONS[type?.toLowerCase?.()] || ARTIFACT_ICONS['default'];
}

export function getArtifactTypeColor(type: string): string {
  return ARTIFACT_TYPE_COLORS[type?.toLowerCase?.()] || ARTIFACT_TYPE_COLORS['default'];
}
